import { useEffect, useState, createContext } from 'react'
import { API_URL } from '../mdc_modules/mdcApiFetch'
import { VITE_PROSEARCH_VERSION } from '../mdc_modules/mdcConsts'

export const AuthContext = createContext({
  loading: true,
  authenticated: false,
  userSettings: {},
  error: undefined,
  reload: async () => undefined,
})

function AuthContextProvider({ children }) {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState()
  const [authenticated, setAuthenticated] = useState(false)
  const [userSettings, setUserSettings] = useState({})

  useEffect(() => {
    const abortController = new AbortController()

    const loadSettings = async () => {
      setLoading(true)
      try {
        const response = await fetch(API_URL + '?getUserSettings=1', {
          credentials: 'include',
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            Settings: { getUserSettings: true, react_app_version: VITE_PROSEARCH_VERSION },
          }),
          signal: abortController.signal,
        })

        if (!response.ok) {
          throw new Error(`Failed to load user settings: ${response.status}`)
        }

        const data = await response.json()

        if (abortController.signal.aborted) {
          return
        }

        if (data.error) {
          setError(data.error)
        } else if (data.UserSettings) {
          setUserSettings(data.UserSettings)
          setAuthenticated(data.UserSettings.authenticated)
        }
      } catch (err) {
        if (err && err.name === 'AbortError') {
          return
        }
        console.error('Error loading user settings:', err)
        if (!abortController.signal.aborted) {
          setError(err instanceof Error ? err.message : 'Failed to load user settings')
        }
      } finally {
        if (!abortController.signal.aborted) {
          setLoading(false)
        }
      }
    }

    loadSettings()

    return () => {
      abortController.abort()
    }
  }, [])

  const contextValue = {
    loading,
    authenticated,
    userSettings,
    error,
    reload: () => window.location.reload(),
  }

  return <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
}

export default AuthContextProvider
